import React from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import MapComponent from "../../../common/components/map-component/map-component";
import { openGoogleMapsDirections } from "../../../api/details-page.api";
import "./LocationComponent.scss";

interface LocationComponentProps {
  providerId?: number;
  type?: "provider" | "planner";
  locationInfo: any;
}

const LocationComponent: React.FC<LocationComponentProps> = ({
  providerId,
  type = "provider",
  locationInfo,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const latitude = locationInfo?.latitude
    ? Number(locationInfo.latitude)
    : null;

  const longitude = locationInfo?.longitude
    ? Number(locationInfo.longitude)
    : null;

  const handleGetDirections = () => {
    if (latitude && longitude) {
      openGoogleMapsDirections(latitude, longitude);
    } else {
      console.warn("Latitude or longitude missing");
    }
  };

  const fullAddress = `${locationInfo?.street_line_1 || ""}${
    locationInfo?.street_line_2 ? `, ${locationInfo.street_line_2}` : ""
  }`;

  console.log("LOCATINO IFNO", locationInfo);

  // --- Mobile Layout ---
  if (isMobile) {
    return (
      <Box className="location-component location-component--mobile">
        <Typography className="location-component__title">Location</Typography>

        <Box className="location-component__address">
          <Typography className="location-component__address-line">
            {locationInfo?.street_line_1}
            {locationInfo?.street_line_2 && `, ${locationInfo.street_line_2}`}
            {", "}
            {locationInfo?.city}, {locationInfo?.state}{" "}
            {locationInfo?.zipcode}{" "}
          </Typography>
        </Box>

        <Box className="location-component__map location-component__map--mobile">
          {latitude && longitude && (
            <MapComponent latitude={latitude} longitude={longitude} />
          )}
        </Box>

        <Button
          className="location-component__directions-btn location-component__directions-btn--mobile"
          onClick={handleGetDirections}
        >
          Get Directions
        </Button>
      </Box>
    );
  }

  // --- Desktop Layout ---
  return (
    <Box className="location-component">
      <Typography className="location-component__title">Location</Typography>

      <Box className="location-component__address">
        <Tooltip
          title={fullAddress}
          disableHoverListener={fullAddress.length < 40}
          arrow
          placement="top"
        >
          <Typography className="location-component__address-line location-component__address-line--clamp">
            {fullAddress || "-"}
          </Typography>
        </Tooltip>

        <Typography className="location-component__address-line">
          {locationInfo?.city || "-"}, {locationInfo?.state || "-"}{" "}
          {locationInfo?.zipcode || "-"}
        </Typography>
      </Box>

      <Box className="location-component__map">
        {latitude && longitude && (
          <MapComponent latitude={latitude} longitude={longitude} />
        )}
      </Box>

      <Button
        className="location-component__directions-btn"
        onClick={handleGetDirections}
      >
        Get Directions
      </Button>
    </Box>
  );
};

export default LocationComponent;
